<div class="ic-admin-tb nt-flex nt-align-items-center gap-8" [class.ic-admin-tb--header]="placement() === 'header'">
  <!-- Laid out as the customer trigger in toolbar-account-select: the globe and name hard left, the buttons hard right where its chevron sits. -->
  @if (accountName()) {
    <!-- The same 20px globe as the customer trigger in toolbar-account-select. -->
    <span class="ic-admin-tb__glyph" aria-hidden="true">
      <ic-icon-svg iconName="globe" [svgResizable]="true"></ic-icon-svg>
    </span>
    <span class="ic-admin-tb__name nt-flex-1 mid-text" [title]="accountName()">{{ accountName() }}</span>
  }

  <div class="ic-admin-tb__actions nt-flex nt-align-items-center gap-8">
    <!-- Opens the account's page, as the retired dashboard bar's admin link did. It opens the account; it never switches it. -->
    <!-- In the header at 1200-1439px it shrinks to its icon, so the 247px segment still has room for the name; the label stays as its aria-label and tooltip. -->
    <!-- The icon is the person-gear of the sidebar's Account item, which Account Select sits under; the Account Details breadcrumbs and the account panel's settings buttons use it too. -->
    @if (accountName()) {
      <ic-button class="ic-admin-tb__details-btn"
          [isSmallBtn]="true"
          [isCompactBtn]="placement() === 'header'"
          [isSecondaryBtnOnDark]="true"
          [ariaLabel]="'HEADER.ACCOUNT_DETAILS' | translate"
          [title]="'HEADER.ACCOUNT_DETAILS' | translate"
          (clickHandler)="onAccountDetailsClick()">
        <span class="ic-admin-tb__details-icon" aria-hidden="true">
          <ic-menu-icons iconName="person-settings" [svgResizable]="true"></ic-menu-icons>
        </span>
        <span class="ic-admin-tb__details-label">{{ 'HEADER.ACCOUNT_DETAILS' | translate }}</span>
      </ic-button>
    }

    <!-- With no preferred account (null or DEFAULT_GUID) the button renders alone. -->
    <!-- In the header it is compact, 30px tall, to match Rain Shutdown in toolbar-user (ER-1572). -->
    <ic-button class="ic-admin-tb__dashboard-btn"
        [isSmallBtn]="true"
        [isCompactBtn]="placement() === 'header'"
        [isSecondaryBtnOnDark]="true"
        (clickHandler)="onAdminDashboardClick()">
      {{ 'STRINGS.ADMIN' | translate }}
    </ic-button>
  </div>
</div>
